import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spin, Tooltip } from 'antd';
import { useParams } from 'react-router-dom';

import Modal from "../../../../../../../components/uiComponent/modal"
import Input from "../../../../../../../components/uiComponent/inputs/input/index"
import ReactSelect from '../../../../../../../components/uiComponent/select';

import { EditModalStyleWrapper } from '../../style'
import { GetWarehouseShipments, UpdateBox, GetPackingItems } from '../../../../../../../slices/post-shipment';

const unitOptions = [
  { value: 'lb', label: 'lb' },
  { value: 'kg', label: 'kg' },
];

const EditBoxDimensionsModal = ({
  setEditBox,
  editBox,
  boxesList,
  boxIndex
}) => {
  const dispatch = useDispatch();
  const { workOrderId } = useParams();

  const [dimensions, setDimensions] = useState({
    height: '',
    width: '',
    length: '',
    weight: '',
    unit: 'lb'
  });

  const {
    updatingBox
  } = useSelector((state) => state.postShipment || {});

  useEffect(() => {
    if (!boxesList?.length) return;

    const { height, width, length, weight, unit } = boxesList[boxIndex] || {};
    setDimensions({ height, width, length, weight, unit });
  }, [boxesList]);

  const getUpdateBtnDisabledStatus = () => {
    const { height, width, length, weight, unit } = dimensions;

    return (
      !height || isNaN(height) || Number(height) <= 0 ||
      !width || isNaN(width) || Number(width) <= 0 ||
      !length || isNaN(length) || Number(length) <= 0 ||
      !weight || isNaN(weight) || Number(weight) <= 0 ||
      !unit || updatingBox
    );
  };

  const handleUpdateBoxDimensions = () => {
    dispatch(UpdateBox({
      boxId: boxesList[boxIndex]?.id,
      ...dimensions
    }))
      .then(() => {
        setEditBox(false);
        dispatch(GetWarehouseShipments({
          workOrderId,
        }));
        dispatch(GetPackingItems({
          workOrderId,
        }));
      });
  };

  const { height, width, length, weight, unit } = dimensions || {};
  console.log({ height, width, length, weight, unit });

  return (
    <Modal saveText="Update"
      onClose={() => setEditBox(false)}
      onSave={handleUpdateBoxDimensions}
      closeText="Cancel"
      size="md"
      open={editBox}
      removeIcon
      buttonDisabled={getUpdateBtnDisabledStatus()}
    >
      <EditModalStyleWrapper>
        <Tooltip title='Edit'>
        <p>Edit Box’s Dimensions</p>
        </Tooltip>
        <Spin tip='Loading...' spinning={updatingBox}>
          <div className='items-wrapper'>
            <Input
              important
              placeholder="Enter"
              label="Length (in)"
              value={length}
              onChange={({ target }) => setDimensions(dimensions => ({ ...dimensions, length: target.value }))}
            />
            <Input
              important
              placeholder="Enter"
              label="Width (in)"
              value={width}
              onChange={({ target }) => setDimensions(dimensions => ({ ...dimensions, width: target.value }))}
            />
            <Input
              important
              placeholder="Enter"
              label="Height (in)"
              value={height}
              onChange={({ target }) => setDimensions(dimensions => ({ ...dimensions, height: target.value }))}
            />
            <Input
              important
              placeholder="Enter"
              label="Empty Box Weight"
              value={weight}
              onChange={({ target }) => setDimensions(dimensions => ({ ...dimensions, weight: target.value }))}
            />
            <ReactSelect
              options={unitOptions}
              placeholder="Select"
              label="Unit"
              important
              value={unit ? { value: unit, label: unit } : null}
              onChange={(e) => setDimensions(dimensions => ({ ...dimensions, unit: e?.value }))}
              style={{ width: '100%' }}
            />
          </div>
        </Spin>
      </EditModalStyleWrapper>
    </Modal>
  )
}

export default EditBoxDimensionsModal